import { observer } from "mobx-react-lite";
import { useTranslation } from "../i18n/useTranslation.js";
import SectionHeading from "../components/SectionHeading.js";

const sections = [
  { index: "01", title: "landing.about.campaignTitle", body: "landing.about.campaignBody" },
  { index: "02", title: "landing.about.engineTitle", body: "landing.about.engineBody" },
  { index: "03", title: "landing.about.narratorTitle", body: "landing.about.narratorBody" },
  { index: "04", title: "landing.about.futureTitle", body: "landing.about.futureBody" },
];

const AboutPage = observer(() => {
  const { t } = useTranslation();
  return (
    <article className="landing-page">
      <SectionHeading eyebrow={t("landing.about.eyebrow")} title={t("landing.about.title")}
        body={t("landing.about.lead")} />
      <div className="landing-prose-grid">
        {sections.map((section) => (
          <section key={section.title}>
            <span aria-hidden="true">{section.index}</span>
            <h2>{t(section.title)}</h2>
            <p>{t(section.body)}</p>
          </section>
        ))}
      </div>
      <aside className="landing-note">
        <p>{t("landing.about.alphaNote")}</p>
      </aside>
    </article>
  );
});

export default AboutPage;
